import { BasePage } from '@/components/ui/base-page'

export function SyphenIBPage() {
  return (
    <BasePage
      title="Syphen IB (Investment Services)"
      description="Investment banking and investment services for institutional clients."
    >
      <div className="prose dark:prose-invert max-w-none">
        <p>Syphen IB provides investment services and solutions for institutional clients. Content and offerings can be expanded here.</p>
      </div>
    </BasePage>
  )
}
